import { ActionTypes } from './actionTypes';
import type { VehiclePopupAction } from './actions';

import { type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';

export interface VehiclePopupState {
  addressWebData: WebData<string>;
}

export const vehiclePopupInitialState: VehiclePopupState = {
  addressWebData: webDataNotAsked(),
};

export const vehiclePopupReducer = (state: VehiclePopupState = vehiclePopupInitialState, action: VehiclePopupAction) => {
  if (!(action.type in ActionTypes)) {
    return state;
  }

  switch (action.type) {
    case ActionTypes.LOAD_ADDRESS_REQUEST:
      return {
        ...state,
        addressWebData: webDataFetching(),
      };

    case ActionTypes.LOAD_ADDRESS_SUCCEEDED:
      return {
        ...state,
        addressWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.LOAD_ADDRESS_FAILED:
      return {
        ...state,
        addressWebData: webDataError(),
      };

    default:
      return state;
  }
};
